import { render, staticRenderFns } from "./AsLowAs.vue?vue&type=template&id=472d74a9"
import script from "./AsLowAs.vue?vue&type=script&lang=js"
export * from "./AsLowAs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports